
import { act, useEffect, useState } from "react";
import "./create-job-question.component.scss"
import { Box, Divider, Step, StepLabel, Stepper } from "@mui/material"
import JobPositionComponent from "./job-position/job-position.component";
import SelectQuestionsComponent from "./select-questions/select-questions.component";
import { Button } from "react-bootstrap";
import SummaryCreateQuestionComponent from "./summary-questions/summary-questions.component";
import config from "../../config";
import { JobPosition, Question, QuestionsSummaryModel } from "../../model/questions-summary.model";
import { postInterviewQuestion } from "../../services/api.service";
import { useNavigate } from "react-router-dom";
import tokenService from "../../services/token.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AI_ICON_PURPLE from "../../assets/images/ai-star-1.png";
import { StepQuestionTopicModel } from "../../model/step-topic-question.model";

const CreateJobQuestionComponent = () => {
    const [activeStep, setActiveStep] = useState(0);
    const steps = [
        'ระบุตำแหน่งงาน',
        'เลือกคำถาม',
        'สรุปคำถาม',
    ];
    const [selectQuestionStep, setSelectQuestionStep] = useState<StepQuestionTopicModel[]>([
        {
            id: 1,
            title: "คำถามทั่วไป",
            desc: "Soft Skill คือ ทักษะที่เกี่ยวข้องกับบุคลิกภาพ การสื่อสาร และการทำงานร่วมกับผู้อื่น ซึ่งไม่สามารถวัดผลเป็นตัวเลขได้โดยตรง แต่มีความสำคัญต่อความสำเร็จในที่ทำงาน",
            is_select: false
        },
        {
            id: 2,
            title: "คำถาม Soft Skill",
            desc: "",
            is_select: false
        },
        {
            id: 3,
            title: "คำถาม Hard Skill",
            desc: "Hard Skill คือ ทักษะที่สามารถเรียนรู้ ฝึกฝน และวัดผลได้อย่างเป็นรูปธรรม มักเกี่ยวข้องกับความรู้ทางเทคนิคหรือทักษะเฉพาะด้านที่ใช้ในการทำงาน",
            is_select: false
        },
        {
            id: 4,
            title: "คำถาม Culture and Behavior",
            desc: "พฤติกรรม คือ การกระทำของบุคคลที่สะท้อนถึงลักษณะนิสัย ทัศนคติ และแนวคิด ซึ่งมีผลต่อการทำงานและการใช้ชีวิตร่วมกับผู้อื่น วัฒนธรรมองค์กร คือ ค่านิยม ความเชื่อ และแนวทางปฏิบัติที่เป็นเอกลักษณ์ขององค์กร ส่งผลต่อวิธีการทำงานและความสัมพันธ์ภายในองค์กร",
            is_select: false
        },
        {
            id: 5,
            title: "สร้างคำถามเพิ่มเติม",
            desc: "คำถามจากบริษัท คือ คำถามที่สร้างขึ้นเองในแต่ละบริษัทโดยมีจุดประสงค์ของคำถามที่แตกต่างกันไป",
            is_select: false
        }

    ]);
    const [interviewModel, setInterviewModel] = useState<any>();
    const [selectedQuestions, setSelectedQuestions] = useState<Question[]>([]);
    const [position, setPosition] = useState<JobPosition>({
        hardware_require: {
            is_camera: false,
            is_mic: false,
            record_video: false
        },
        interview_language: [],
        interview_time: 30,
        tone: {
            title: "Professional",
            description: ""
        },
        company_id: tokenService.getHR9CompanyUUID() + "",
        company_logo: "",
        company_name: "",
        name: "",
        question_type: "voice",
        job_title: "",
        job_advance: {},
        job_exp: "",
        job_level: "",
        job_salary: "",
        job_department: "",
        job_industry: "",
        job_employment: "",
        job_work_type: "",
        default: {},
        candidate_require: {
            email: true,
            firstname: true,
            lastname: true,
            resume: true
        }
    });

    const [isSubmitStep1, setIsSubmitStep1] = useState(false);
    const [isSubmitStep2, setIsSubmitStep2] = useState(false);
    const [isSubmitStep3, setIsSubmitStep3] = useState(false);
    const [isSubmittingCreate, setIsSubmittingCreate] = useState(false);
    const [activeStepQuestion, setActiveStepQuestion] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
    }, [tokenService.getProfile()])

    const onSubmitStep1 = (value) => {
        console.log(value);
        if (value == 500) {
            setIsSubmitStep1(false);
        } else {
            const jobPositionValue = value?.job_position ? value.job_position : value;

            setPosition(jobPositionValue);
            const interviewMod = { ...interviewModel };
            interviewMod.job_position = jobPositionValue;
            setInterviewModel(interviewMod);
            setIsSubmitStep1(false);
            setActiveStep(1);
        }

    }

    const onSubmitButton = () => {
        if (isSubmittingCreate) return;
        console.log("activeStep", activeStep);
        if (activeStep == 0) {
            setIsSubmitStep1(false);
            setTimeout(() => setIsSubmitStep1(true), 0);
        } else if (activeStep == 1) {
            setIsSubmitStep2(false);
            setTimeout(() => setIsSubmitStep2(true), 0);
        } else if (activeStep == 2) {
            setIsSubmitStep3(false);
            setTimeout(() => setIsSubmitStep3(true), 0);
        }
    }

    const onSubmitStep2 = (value) => {
        const interviewMod = { ...interviewModel };
        interviewMod.questions = selectedQuestions
        interviewMod.default_step_2 = value
        setInterviewModel(interviewMod);
        console.log(interviewMod);
        setIsSubmitStep2(false);
        setActiveStep(2);
    }


    const onSubmitStep3 = (value) => {
        if (isSubmittingCreate) return;
        const result = value as QuestionsSummaryModel;
        if (tokenService.getProfile() && tokenService.getProfile().email) {
            result["email"] = tokenService.getProfile().email;
        } else {
            result["email"] = "-";
        }
        setIsSubmittingCreate(true);
        postInterviewQuestion(result).then(res => {
            console.log(res)
            if (res.data.is_success) {
                navigate("/" + tokenService.getHR9CompanyUUID() + "/job-questions-list")
                return;
            }
            alert(res?.data?.error || "สร้างชุดคำถามไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
            setIsSubmittingCreate(false);
        }).catch((error) => {
            console.error(error);
            alert(error?.response?.data?.error || "สร้างชุดคำถามไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
            setIsSubmittingCreate(false);
        });
        // Keep previously built step-2 data/state so user can go back without losing selections.
        setInterviewModel((prev) => ({ ...(prev || {}), ...(value || {}) }));
    }
    const onBack = () => {
        console.log(Number(activeStep) - 1)
        setActiveStep(Number(activeStep) - 1);
        if (Number(activeStep) == 1) {
            setIsSubmitStep1(false);
        }else if(Number(activeStep) == 2){
            setIsSubmitStep2(false);
        }
    }

    const onSetSelectQuestions = (value: React.SetStateAction<Question[]>) => {
        const updatedQuestions: Question[] =
            typeof value === "function" ? value(selectedQuestions) : value;

        // Initialize category-wise question groups
        const questionGroups: Record<string, Question[]> = {
            general: [],
            soft_skill: [],
            hard_skill: [],
            behavior: [],
            standard_questions: [],
            custom_questions: [],
        };

        // Categorize questions
        updatedQuestions.forEach((item) => {
            const topic = item.topic || "custom_questions"; // Default to custom if topic is undefined
            (questionGroups[topic] || questionGroups["custom_questions"]).push(item);
        });
        setSelectedQuestions(updatedQuestions);

        // Update interviewModel efficiently
        setInterviewModel((prev) => ({
            ...prev,
            selected_questions: {
                ...prev.selected_questions,
                ...questionGroups,
            },
        }));

        // Update selected questions
        setSelectedQuestions(updatedQuestions);
    };


    const onCompleteGenerateQuestions = (status, general, soft_skill, hard_skill, behavior_skill) => {
        if (interviewModel) {
            console.log("onCompleteGenerateQuestions", status, general, soft_skill, hard_skill, behavior_skill);
            const interviewMod = { ...interviewModel };
            interviewMod.all_question_step_2 = {
                general,
                soft_skill, hard_skill,
                behavior_skill,
                status
            }
            setInterviewModel(interviewMod);
        }

    }

    const scrollToSection = (item) => {
        setActiveStepQuestion(item.id);
    }

    return (
        <>
            <div className="create-job-question-control">
                {
                    activeStep == 1 &&
                    <div className="create-job-side-control">
                        <div className="create-job-sticky-control">
                            {
                                selectQuestionStep.map((item, index) => {
                                    return (
                                        item.is_select ?
                                            <div className="side-step-extra-control" key={index} onClick={() => scrollToSection(item)}>
                                                <div className="side-active-control">
                                                    <div className="side-icon-control">
                                                        <img src={AI_ICON_PURPLE} className="side-icon"></img>
                                                    </div>
                                                    <span className="side-text">{item.title}</span>
                                                </div>
                                                {
                                                    index == selectQuestionStep.length - 1 &&
                                                    <div className="d-flex flex-column">
                                                        <div className="side-child-control">
                                                            <div className="side-icon-control">
                                                                <div className="side-icon"></div>
                                                            </div>
                                                            <span className="side-text">คำถามจากบริษัท</span>
                                                        </div>
                                                        <div className="side-child-control">
                                                            <div className="side-icon-control">
                                                                <div className="side-icon"></div>
                                                            </div>
                                                            <span className="side-text">คำถามจากประวัติผู้สมัคร</span>
                                                        </div>
                                                    </div>

                                                }

                                            </div>
                                            :
                                            <div className="side-step-extra-control" key={index} onClick={() => scrollToSection(item)}>
                                                <div className="side-normal-control" >
                                                    <div className="side-icon-control">
                                                        <div className="side-icon"></div>
                                                    </div>
                                                    <span className="side-text">{item.title}</span>
                                                </div>

                                            </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                <div className="create-job-question-steps">
                    <div className="create-job-question-steps-top-control" >
                        <div className="stepper-control">
                            {
                                steps.map((item, index) => {

                                    return (
                                        index == activeStep ?
                                            <div className="stepper-active-control" key={index} onClick={() => setActiveStep(index)}>
                                                <div className="stepper-active-number-control">
                                                    <div className="stepper-active-number">
                                                        {Number(activeStep) + 1}
                                                    </div>
                                                </div>
                                                <span className="stepper-active-text">{item}</span>
                                            </div> :

                                            activeStep > index ?
                                                <div className="stepper-complete-control" key={index} onClick={() => setActiveStep(index)}>

                                                    <div className="stepper-complete-number-control">
                                                        <div className="stepper-complete-number">
                                                            {Number(index) + 1}
                                                        </div>
                                                    </div>
                                                    <span className="stepper-complete-text">{item}</span>
                                                    <Divider className="stepper-divider-control"></Divider>
                                                </div> :

                                                <div className="stepper-normal-control" key={index} onClick={() => setActiveStep(index)}>
                                                    <Divider className="stepper-divider-control"></Divider>
                                                    <div className="stepper-normal-number-control">
                                                        <div className="stepper-normal-number">
                                                            {Number(index) + 1}
                                                        </div>
                                                    </div>
                                                    <span className="stepper-normal-text">{item}</span>
                                                </div>

                                    )
                                })
                            }
                        </div>

                    </div>
                    <div className="create-job-question-content-control">
                        {
                            activeStep == 0 ?

                                <JobPositionComponent setSubmitStep={setIsSubmitStep1} isSubmitStep1={isSubmitStep1} position={position} onSubmit={onSubmitStep1} />
                                : activeStep == 1 ?
                                    <SelectQuestionsComponent
                                        setActiveStepQuestion={setActiveStepQuestion}
                                        activeStep={activeStepQuestion}
                                        setSelectQuestionStep={setSelectQuestionStep}
                                        selectQuestionStep={selectQuestionStep}
                                        onCompleteGenerate={onCompleteGenerateQuestions}
                                        isSubmitStep2={isSubmitStep2}
                                        interviewModel={interviewModel}
                                        selectedQuestions={selectedQuestions} onSetSelectQuestions={onSetSelectQuestions}
                                        job_position={position} onSubmit={onSubmitStep2} />
                                    :
                                    activeStep == 2 &&

                                    <SummaryCreateQuestionComponent
                                        isSubmitStep4={isSubmitStep3}
                                        onBack={onBack}
                                        interview={interviewModel}
                                        onSubmit={onSubmitStep3} />


                        }
                    </div>

                    <div className="border-std button-control">
                        {
                            activeStep == 1 &&
                            <div className="select-questions-question-amount-control">
                                <span className="select-questions-question-amount-title">คำถามที่คุณเลือก: </span>
                                <span className="big-number">{selectedQuestions.length}</span>
                                <span className="amount-number"> / {config.questions.normal_question}</span>
                            </div>
                        }

                        <div className="button-left-control">
                            {
                                activeStep !== 0 &&
                                <Button className="button-back" onClick={onBack} >ย้อนกลับ</Button>
                            }

                            <Button
                                disabled={isSubmittingCreate}
                                onClick={() => onSubmitButton()}
                                className={activeStep !== 0 &&
                                    activeStep !== 2 ? "button-std button-submit" : "button-std button-submit  button-left-margin"}>
                                {isSubmittingCreate ? "กำลังสร้าง..." : activeStep == 2 ? "สร้างชุดคำถามนี้" : "ถัดไป"} {activeStep !== 2 && <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>}
                            </Button>
                        </div>

                    </div>


                </div>




            </div>
        </>
    )
}

export default CreateJobQuestionComponent;